import React, {useMemo, useState} from "react";
import {Button, Checkbox, Dialog, DialogActions, DialogContent, FormControlLabel} from "@mui/material";
import {ClosableDialogTitle, SelectField} from "@atttomyx/react-components";
import {forms} from "@atttomyx/shared-utils";

const ChooseQuestionnaireDialog = (props) => {
    const { questionnaires, onCancel, onChoose } = props;
    const [ questionnaireId, setQuestionnaireId ] = useState(null);
    const [ prerequisite, setPrerequisite ] = useState(false);

    const questionnaireIdToTitle = useMemo(() => {
        const idToField = {};

        questionnaires.map(questionnaire => idToField[questionnaire.id] = questionnaire.title);

        return idToField;
    }, [questionnaires]);

    return <Dialog
        open={true}
        aria-labelledby="choose-questionnaire-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Add Form
        </ClosableDialogTitle>
        <DialogContent className="choose-questionnaire-dialog">
            <div className="field top-margin">
                <SelectField
                    label="Form"
                    value={forms.sanitizeValue(questionnaireId)}
                    onChange={setQuestionnaireId}
                    options={questionnaireIdToTitle}
                />
            </div>
            <div className="option">
                <FormControlLabel
                    label="Prerequisite?"
                    control={<Checkbox
                        color="primary"
                        checked={forms.sanitizeOption(prerequisite)}
                        onChange={(event) => setPrerequisite(event.target.checked)}
                    />}
                />
            </div>
        </DialogContent>
        <DialogActions>
            <Button color="primary"
                    disabled={!questionnaireId}
                    onClick={() => onChoose(questionnaireId, prerequisite)}>
                Save
            </Button>
        </DialogActions>
    </Dialog>
}

export default ChooseQuestionnaireDialog;
